export enum AvailabilityStatus {
  NOT_AVAILABLE,
  PARTIALLY_AVAILABLE,
  FULLY_AVAILABLE,
}
